import React, { useEffect, useState } from 'react';
import axios from 'axios'
import { Panel, PanelHeader, PanelBody } from '../../components/panel/panel.jsx';
import Select, { components } from 'react-select';
import 'react-tabs/style/react-tabs.css';
import { toast } from 'react-toastify';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';

import Switch from "react-switch";
import { isEmpty } from "../../helper/helper.js"

function UserForm({ props = { id: null } }) {


  const [appData, setAppData] = useState({ active: true })
  const [formData, setFormData] = useState({
    mProvince: [],
    mCity: [],
    mDistrict: [],
    mSubDistrict: []
  });

  const handleOnChangeInputText = (e) => {
    const { name, value } = e.target
    setAppData(prevState => ({
      ...prevState,
      [name]: value
    }))
  }

  const handleOnChangeSwitch = async (c, e, id) => {
    setAppData(prevState => ({ ...prevState, [id]: c }))
  }


  // Custom Option component for the dropdown menu
  const CustomOption = (props) => {
    return (
      <components.Option {...props}>
        <div>{props.data.label} - <span className='fw-bold fs-6'>{props.data.postalcode}</span></div>
      </components.Option>
    );
  };

  const onChangeProvince = async (option, e) => {
    if (e.action === "select-option") {
      setAppData(prevState => ({
        ...prevState,
        province: option.value,
        provinceName: option.label,
        city: '',
        cityName: '',
        district: '',
        districtName: '',
        subdistrict: '',
        subdistrictName: '',
        postalCode: ''
      }))

      await axios.get(`${window.API_HOST}/ui/v1/form/city`, {
        params: { prov_code: option.value }
      }).then(async (res) => {
        const resp = res.data
        const cities = resp.data.city;
        setFormData(prevState => ({ ...prevState, mCity: cities }))
      }).catch(err => {
      })
    } else if (e.action === "clear") {
      setAppData(prevState => ({
        ...prevState,
        province: '',
        provinceName: '',
        city: '',
        cityName: '',
        district: '',
        districtName: '',
        subdistrict: '',
        subdistrictName: '',
        postalCode: ''
      }))

      setFormData(prevState => ({
        ...prevState,
        mCity: [],
        mDistrict: [],
        mSubDistrict: []
      }))
    }
  }

  const onChangeCity = async (option, e) => {
    if (e.action === "select-option") {
      setAppData(prevState => ({
        ...prevState,
        city: option.value,
        cityName: option.label,
        district: '',
        districtName: '',
        subdistrict: '',
        subdistrictName: '',
        postalCode: ''
      }))

      await axios.get(`${window.API_HOST}/ui/v1/form/district`, {
        params: { city_code: option.value }
      }).then(async (res) => {
        const resp = res.data
        const districts = resp.data.district;
        setFormData(prevState => ({ ...prevState, mDistrict: districts }))
      }).catch(err => {
      })

    } else if (e.action === "clear") {
      setAppData(prevState => ({
        ...prevState,
        city: '',
        cityName: '',
        district: '',
        districtName: '',
        subdistrict: '',
        subdistrictName: '',
        postalCode: ''
      }))

      setFormData(prevState => ({
        ...prevState,
        mDistrict: [],
        mSubDistrict: []
      }))
    }

  }

  const onChangeDistrict = async (option, e) => {
    if (e.action === "select-option") {
      setAppData(prevState => ({
        ...prevState,
        district: option.value,
        districtName: option.label,
        subdistrict: '',
        subdistrictName: '',
        postalCode: ''
      }))

      await axios.get(`${window.API_HOST}/ui/v1/form/subdistrict`, {
        district_code: option.value
      }).then(async (res) => {
        const subdistricts = res.data.subdistrict ?? [];
        console.log(subdistricts)
        setFormData(prevState => ({ ...prevState, mSubDistrict: subdistricts }))
      }).catch(err => {
      })

    } else if (e.action === "clear") {
      setAppData(prevState => ({
        ...prevState,
        district: '',
        districtName: '',
        subdistrict: '',
        subdistrictName: '',
        postalCode: ''
      }))

      setFormData(prevState => ({
        ...prevState,
        mDistrict: [],
        mSubDistrict: []
      }))
    }

  }

  const onChangeSubDistrictPostalCode = async (option, e) => {

    if (e.action === "select-option") {
      setAppData(prevState => ({
        ...prevState,
        subDistrict: option.value,
        subDistrictName: option.label,
        postalCode: option.postalcode
      }))

    } else if (e.action === "clear") {
      setAppData(prevState => ({
        ...prevState,
        subDistrict: '',
        subDistrictName: '',
        postalCode: '',
      }))

    }
  }

  const saveAction = async (e) => {
    e.preventDefault()

    let payload = {
      code: appData.code,
      name: appData.name,
      alias: appData.alias,
      endpoint: appData.endpoint,
      configs: appData.configs,
      address: appData.address,
      province: appData.province,
      provinceName: appData.provinceName,
      city: appData.city,
      cityName: appData.cityName,
      district: appData.district,
      districtName: appData.districtName,
      subdistrict: appData.subDistrict,
      subdistrictName: appData.subDistrictName,
      postalcode: appData.postalCode,
      phone: appData.phone,
      email: appData.email,
      active: appData.active,
    }

    /**
     * check / validate data 
     */

    if (isEmpty(appData.code) || isEmpty(appData.name)) {
      toast.error('Code / Name is required')
      return
    }

    if (!props.uid) {
      // New 
      await axios.post(`${window.API_HOST}/v1/courier`, payload).then(async (res) => {
        const resp = res.data
        setAppData(prevState => ({
          ...prevState,
          uid: resp.data.uid,
          updated_at: resp.data.updated_at,
          updated_by: resp.data.updated_by
        }))
        props.uid = resp.data.uid
        toast.success(`Success save courier ${appData.name}`)
      }).catch(err => {
        toast.error(err.response.data.error)
      })
    } else {

      //Update
      await axios.put(`${window.API_HOST}/v1/courier/${props.uid}`, payload).then(async (res) => {
        const resp = res.data

        setAppData(prevState => ({
          ...prevState,
          updated_at: resp.data.updated_at,
          updated_by: resp.data.updated_by
        }))
        toast.success(`Success update courier ${appData.name}`)
      }).catch(err => {
        toast.error(err.response.data.error)
      })

    }

  }

  const retrieveData = async () => {
    await axios.get(`${window.API_HOST}/v1/user/${props.uid}`).then(async (res) => {
      const resp = res.data

      setAppData(prevState => ({
        ...prevState,
        username: resp?.data?.username,
        email: resp?.data?.email,
        fullname: resp?.data?.fullname,
        mfa: resp?.data?.mfa,
        mfa_recovery_code: resp?.data?.mfa_recovery_code,
        change_passwd_next_login: resp?.data.change_passwd_next_login,
        updated_at: resp?.data?.updated_at,
        updated_by: resp?.data?.updated_by
      }))

    }).catch(err => {
      toast.error(err.response.data.error)
    })

  }

  async function fetchForm() {
    await axios.get(`${window.API_HOST}/v1/user/form`)
      .then(res => {
        const resp = res.data;
        setFormData(prevState => ({
          ...prevState,
          mProvince: resp?.data?.province ?? [],
          mRole: resp?.data?.role ?? [],
          mAccount: resp?.data?.account ?? [],
        }))

      }).catch(err => {
      })
  }

  useEffect(() => {

    //load ui data form
    fetchForm()

    if (props?.uid) {
      console.log(formData)
      retrieveData()
    }

  }, []);

  return (
    <div>
      <div className='m-0 p-0' >
        <Panel >
          <PanelHeader className="bg-purple-200  p-2 p-r-0" noButton>
            <div className='row'>
              <div className='col-sm-6 fw-bolder fs-2 text-black'>{props.uid ? 'Update' : 'Create'} User</div>
              <div className='col-sm-6 align-items-baseline text-end'>
                <div className=''>
                  {(true) ? <button className="btn btn-sm btn-primary ms-3 f-s-11 text-center ml-3" onClick={saveAction}><i className="fa fa-save"></i> Save</button> : null}
                  {(true) ? <button className="btn btn-sm btn-danger ms-3 f-s-11 text-center ml-3" onClick={props.cancelAction}><i className="fa fa-minus-circle"></i> Close</button> : null}
                </div>

              </div>
            </div>
          </PanelHeader>
          <PanelBody>
            <div className="row" >
              <div className='col-sm-9'>
                <div className="form-group row mb-1">
                  <label className="col-sm-3 col-form-label">Username</label>
                  <div className="col-sm-8">
                    <input type="text" name="username" value={appData.username ?? ""} onChange={handleOnChangeInputText} className="form-control form-control-sm" disabled={props.uid} />
                  </div>
                </div>
                <div className="form-group row mb-1">
                  <label className="col-sm-3 col-form-label">Full Name</label>
                  <div className="col-sm-8">
                    <input type="text" name="fullname" value={appData.fullname ?? ""} onChange={handleOnChangeInputText} className="form-control form-control-sm" />
                  </div>
                </div>
                <div className="form-group row mb-1">
                  <label className="col-sm-3 col-form-label">Email</label>
                  <div className="col-sm-8">
                    <input type="email" name="email" value={appData.email ?? ""} onChange={handleOnChangeInputText} className="form-control form-control-sm" autoComplete="off" />
                  </div>
                </div>
                {(!props?.uid) ?
                  <>
                    <div className="form-group row mt-3 mb-2">
                      <label class="col-sm-3 form-label" for="exampleInputEmail1">&nbsp;</label>
                      <div className="col-sm-8">
                        <label class="label" for="exampleInputEmail1" autoComplete='false'>aPassword</label>
                        <button className='btn btn-sm btn-default ms-3'>Generate New Password</button>
                      </div>
                    </div>
                    <div className="form-group row mb-1">
                      <label className="col-sm-3 col-form-label">Password</label>
                      <div className="col-sm-8">
                        <input type="password" name="password" value={appData.password ?? ""} onChange={handleOnChangeInputText} className="form-control form-control-sm" autoComplete="off" />
                      </div>
                    </div>
                    <div className="form-group row mb-1">
                      <label className="col-sm-3 col-form-label">Confirm Password</label>
                      <div className="col-sm-8">
                        <input type="password" name="confirm_password" value={appData.confirm_password ?? ""} onChange={handleOnChangeInputText} className="form-control form-control-sm" />
                      </div>
                    </div>
                  </>
                  :
                  ''}

                <div className="form-group row mt-3 ">
                  <label className="col-sm-3 col-form-label">&nbsp;</label>
                  <div className="col-sm-8">
                    <div class="row row-cols-lg-auto g-3 align-items-center">
                      <div class="col-12">
                        <label class="col-form-label" for='change_passwd_next_login'>Change Password Next Login</label>
                      </div>
                      <div class="col-12">
                        <Switch id="change_passwd_next_login" name="change_passwd_next_login" onChange={handleOnChangeSwitch} checked={appData.change_passwd_next_login ?? false} className='me-3' />
                      </div>
                      <div class="col-12">
                        <label class="col-form-label" for="mfa">MFA Active</label>
                      </div>
                      <div class="col-12">
                        <Switch id="mfa" name="mfa" onChange={handleOnChangeSwitch} checked={appData.mfa ?? false} className='ms-2' />
                      </div>
                    </div>
                  </div>
                </div>
                <div className="form-group row mb-2">
                  <label className="col-sm-3 col-form-label">Active</label>
                  <div className="col-sm-8">
                    <Switch id="active" name="active" onChange={handleOnChangeSwitch} checked={appData.active ?? false} />
                  </div>
                </div>
                <div className="form-group row mb-1">
                  <label className="col-sm-3 col-form-label">Updated By</label>
                  <div className="col-sm-8">
                    <div className='row'>
                      <div className='col-sm-6'>
                        <input type="text" value={appData.updated_by ?? ""} className="form-control form-control-sm" disabled={true} />
                      </div>
                      <div className='col-sm-6'>
                        <input type="text" value={appData.updated_at ?? ""} className="form-control form-control-sm" disabled={true} />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className='col-sm-3'>
                <div className='row'>
                  <div className='col-sm-12 text-center'>
                    <div class="profile-header-img">
                      <img src="../assets/img/user/user-13.jpg" alt="" />
                    </div>
                  </div>
                  <div className='col-sm-12 text-center mt-5'>
                    <input class="form-control" type="file" id="formFile" />
                  </div>
                </div>

              </div>
            </div>
            <div className="row mt-3">
              <Tabs className="m-0 p-0 h-600px" style={{ 'width': '900px', }}>
                <TabList>
                  <Tab><i className="fa fa-address-card"></i> Contact Info</Tab>
                  <Tab><span className="fa fa-lock"></span> Roles &nbsp; Assignment</Tab>
                  <Tab><i className="fa fa-shield-blank"></i> Security</Tab>
                </TabList>

                <TabPanel>
                  <div className="row">
                    <div className='col-sm-12 bg-grey-transparent-1 pt-2'>
                      <div className="form-group row mb-1">
                        <div className="col-sm-12">
                          <textarea name="address"
                            onChange={handleOnChangeInputText} value={appData.address ?? ""}
                            className='form-control form-control-sm' placeholder="Address" ></textarea>
                        </div>
                      </div>
                      <div className="form-group row mb-1">
                        <div className="col-sm-6">
                          <Select name="province" placeholder={"Province"}
                            value={formData.mProvince.find(({ value }) => { return value === appData.province }) ?? ""}
                            options={formData.mProvince}
                            onChange={onChangeProvince}
                            isClearable={true} isSearchable={true} />
                        </div>
                        <div className="col-sm-6">
                          <Select name="city" placeholder={"City"}
                            value={formData.mCity.find(({ value }) => { return value === appData.city }) ?? ""}
                            options={formData.mCity}
                            onChange={onChangeCity}
                            isClearable={true} isSearchable={true} />
                        </div>
                      </div>
                      <div className="form-group row mb-1">
                        <div className="col-sm-6">
                          <Select name="district" placeholder={"District"}
                            value={formData.mDistrict.find(({ value }) => { return value === appData.district; }) ?? ""}
                            options={formData.mDistrict}
                            onChange={onChangeDistrict}

                            isClearable={true} isSearchable={true} />
                        </div>
                        <div className="col-sm-6">
                          <Select name="subDistrict" placeholder={"Sub District"}
                            value={formData.mSubDistrict.find(({ value }) => { return value === appData.subDistrict }) ?? ""}
                            options={formData.mSubDistrict}
                            onChange={onChangeSubDistrictPostalCode}
                            components={{ Option: CustomOption }}
                            isClearable={true} isSearchable={true} />
                        </div>
                      </div>
                      <div className="form-group row mb-1">
                        <div className="col-sm-6">
                          <input type="text" name="postalCode" value={appData.postalCode ?? ""} onChange={handleOnChangeInputText} className="form-control form-control-sm" placeholder='Postal Code' />
                        </div>
                        <div className="col-sm-6">
                          <input type="text" value={appData.originHub} onChange={() => { }} className="form-control form-control-sm bg-grey-transparent-1" readOnly={true} disabled />
                        </div>
                      </div>
                      <div className="form-group row mb-1">
                        <div className="col-sm-6">
                          <input type="text" name="phone" value={appData.phone ?? ""}
                            onChange={handleOnChangeInputText}
                            className="form-control form-control-sm" placeholder="Phone" />
                        </div>
                        <div className="col-sm-6">
                          <input type="text" name="email" value={appData.email ?? ""}
                            onChange={handleOnChangeInputText}
                            className="form-control form-control-sm" placeholder="Email" />
                        </div>
                      </div>
                    </div>

                  </div>
                </TabPanel>
                <TabPanel>
                  <div className="row m-0 p-0" >
                    <div className="col-sm-5 m-0 p-1 me-3">
                      <div className='row'>
                        <div className='col-sm-12 mb-1'>
                          <strong>ASSIGNED ROLES</strong>
                        </div>
                        <div className='col-sm-12 mb-2'>
                          <div class="form-check">
                            <input className="form-check-input" type="checkbox" id="checkall_assigned_roles" />
                            <label className="form-check-label" for="checkall_assigned_roles">Check All</label>
                          </div>
                        </div>
                        <div className='col-sm-12'> 
                          <div className="form-group">
                            {(formData.mRole ?? []).map((val, key) => {
                              return (  
                              <div className="input-group mb-5px">
                                <div className="input-group-text">
                                  <input type="checkbox" className="form-check-input" id={`role-${val.value}`} name={val.value} />
                                </div>
                                <label className="form-control form-check-label" for={`role-${val.value}`}>{val.label}</label>
                                {/* <input type="text" className="form-control" value={val.label} placeholder={val.label} for={`role-${val.value}`} disabled /> */}
                              </div> )
                            })}
 
                          </div>
                        </div>
                      </div>

                    </div>

                    <div className="col-sm-6 m-0 p-1 me-3">
                      <div className='row'>
                        <div className='col-sm-12 mb-1'>
                          <strong>ASSIGNED ACCOUNT</strong>
                        </div>
                        <div className='col-sm-12 mb-2'>
                          <div class="form-check">
                            <input className="form-check-input" type="checkbox" id="checkall_assigned_account" />
                            <label className="form-check-label" for="checkall_assigned_account">Check All</label>
                          </div>
                        </div>
                        <div className='col-sm-12'>
                          <div className="form-group">

                            {(formData.mAccount ?? []).map((val, key) => {
                              return ( 
                              <div className="input-group mb-5px">
                                <div className="input-group-text">
                                  <input type="checkbox" className="form-check-input" name='accounts[]'  id={`acc-${val.value}`} value={val.value} />
                                </div>
                                <label className="form-control form-check-label" for={`acc-${val.value}`}>{val.label}</label> 
                              </div>
                              )
                            })} 
                          </div>
                        </div>
                      </div>


                    </div>

                  </div>
                </TabPanel>
                <TabPanel>
                  <div className="row m-0 p-0" >
                    <div className="col-sm-12 m-0 p-0">
                      <div className="form-group row mb-1">
                        <label className="col-sm-3 col-form-label">Recovery Code</label>
                        <div className="col-sm-8">
                          <div className='row'>
                            <div className='col-sm-7'>
                              <input id='recoveryCode' type="text" name="recoveryCode" value={appData.recoveryCode ?? ""} onChange={handleOnChangeInputText} className="form-control form-control-sm text-red" readOnly disabled={true} />
                            </div>
                            <div className='col-sm-2'>
                              <button className='btn btn-sm btn-default'><i className='fa fa-eye'></i> Show</button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </TabPanel>
              </Tabs>
            </div>
          </PanelBody>
        </Panel>
      </div>
    </div>

  )


}

export default UserForm